export class CoreUrlProvider {
  private static _apiBackendUrl: string = '/api/backend';
  private static _apiOrganisationUrl: string = '/api/organisation';
  static readonly URL = {
    ADMIN: {
      BATCH: {
        RESIZE: `/api/backend/admin-area/batch/{id}/scale`,
        DELETE: `/api/backend/admin-area/batch/{id}`,
        NODES: `/api/backend/admin-area/batch/{id}/nodes`,
        JOBS: `/api/backend/admin-area/batch/{id}/jobs`,
      },
      LOGS: `/api/backend/admin-area/event-log`,
      SETTINGS: `/api/backend/admin-area/application-property`,
    },
    AIRCRAFT_TYPES: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/dictionary/aircraft-type`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/dictionary/aircraft-type/{uuid}`,
    },
    AIRPORTS: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/dictionary/airport`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/dictionary/airport/{uuid}`,
      COUNT: `${CoreUrlProvider._apiBackendUrl}/dictionary/airport/count`,
    },
    AUTH: {
      LOGOUT: `/oidc/connect/logout`,
      USER_ME: `${CoreUrlProvider._apiOrganisationUrl}/user/me`,
      USER_ME_PASSWORD: `${CoreUrlProvider._apiOrganisationUrl}/user/me/password`,
      USER_DETAILS: `${CoreUrlProvider._apiOrganisationUrl}/user/{userUuid}/security-details`,
    },
    COUNTRIES: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/dictionary/country`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/dictionary/country/{uuid}`,
    },
    DICTIONARIES: {
      TYPE: `${CoreUrlProvider._apiBackendUrl}/dictionary/{type}`,
      DICTIONARY_VALUES: `${CoreUrlProvider._apiBackendUrl}/dictionary/{type}/value`,
    },
    LINES_OF_FLYING: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/lines-of-flying`,
      LIST_BY_DATE: `${CoreUrlProvider._apiBackendUrl}/lines-of-flying/{date}`,
      UPDATE_STATUS: `${CoreUrlProvider._apiBackendUrl}/lines-of-flying/aircraft/{uuid}/status`,
    },
    AIRCRAFT_DAILY_PROGRAMME: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/aircraft-daily-programme`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/aircraft-daily-programme/{uuid}`,
      AIRCRAFT_FLIGHTS: `${CoreUrlProvider._apiBackendUrl}/aircraft-daily-programme/{uuid}/flight`,
      INPUT: `${CoreUrlProvider._apiBackendUrl}/aircraft-daily-programme/{uuid}/model/input`,
      LOGS: `${CoreUrlProvider._apiBackendUrl}/aircraft-daily-programme/{uuid}/model/logs`,
      RESULT: `${CoreUrlProvider._apiBackendUrl}/aircraft-daily-programme/{uuid}/model/result`,
      RUN: `${CoreUrlProvider._apiBackendUrl}/aircraft-daily-programme/{uuid}/model/run`,
      TERMINATE: `${CoreUrlProvider._apiBackendUrl}/aircraft-daily-programme/{uuid}/model/terminate`,
    },
    MODELS: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/model`,
      BASE_SHORT: `${CoreUrlProvider._apiBackendUrl}/model/short`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/model/{uuid}`,
      BASE_UUID_DESCRIPTION: `${CoreUrlProvider._apiBackendUrl}/model/{uuid}/description`,
    },
    OPERATIONAL: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/operational`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/operational/{uuid}`,
      LIST_BY_DATE: `${CoreUrlProvider._apiBackendUrl}/operational/day/{date}`,
      DAYS: `${CoreUrlProvider._apiBackendUrl}/operational/days`,
    },
    PROFILES: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/profile`,
      BASE_SHORT: `${CoreUrlProvider._apiBackendUrl}/profile/short`,
      BASE_ID: `${CoreUrlProvider._apiBackendUrl}/profile/{id}`,
      DELETE: `${CoreUrlProvider._apiBackendUrl}/profile/{id}/type/{profileType}`,
    },
    RELEASE_NOTES: {
      SYSTEM: `../assets/release-notes/application-release-notes.json`,
      MODEL: `../assets/release-notes/model-release-notes.json`,
      USER_MANUAL: `../assets/user-manual/ADAPUserManual.pdf`,
    },
    USERS: {
      BASE: `${CoreUrlProvider._apiOrganisationUrl}/user`,
      BASE_UUID: `${CoreUrlProvider._apiOrganisationUrl}/user/{uuid}`,
      UNLOCK: `${CoreUrlProvider._apiOrganisationUrl}/user/{uuid}/unlock`,
    },
    CACHE: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/cache/authenticated-user-cache/{uuid}`,
    },
    SSE: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/optimisation/evaluation/result/subscribe`, //TODO: REVIEW
    },
    SCHEDULES: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/flight-schedule`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/flight-schedule/{uuid}`,
      FLIGHTS: `${CoreUrlProvider._apiBackendUrl}/flight-schedule/{uuid}/flight`,
    },
    FLEET_INFORMATION: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/fleet-information`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/fleet-information/{uuid}`,
    },
    RUN_CONFIGURATION: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/run-configuration`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/run-configuration/{uuid}`,
    },
  };
}
